import {
    DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL,
    DASHBOARD_PANEL_DELETE_GADGET_REQUEST,
    DASHBOARD_PANEL_DELETE_GADGET_RESULT,
    CLEAR_REDUX
} from "Redux/actionTypes";

const INITIAL_STATE = {
    loading: false,
    result: null,
    openModal: false,
    gadget: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, gadget: action.payload.data }

        case DASHBOARD_PANEL_DELETE_GADGET_REQUEST:
            return { ...state, result: null, loading: true };

        case DASHBOARD_PANEL_DELETE_GADGET_RESULT:
            return { ...state, result: action.payload?.data, loading: false };

        case CLEAR_REDUX:
            return ["", "DASHBOARD_PANEL_DELETE_GADGET"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INITIAL_STATE }
                : { ...state };

        default:
            return state;
    }
};